import { useState } from "react";
const { v4: uuidv4 } = require('uuid');

export const useMessageQueue =() => {
    const [messages, setMessages] = useState([]);
    const [newMessage,setNewMessage] = useState();


    function addMessage(text,data,anim) {
        let msg = {uid: uuidv4(), message: text,other: data , anim: anim};
        messages.push(msg);
        setMessages(messages);
        setNewMessage(msg);
    }


    function consumeMessage() {
        let msg =  messages.shift();
        setMessages(messages);
        return msg;
    }

    function size() {
        return messages.length;
    }


    return { addMessage, consumeMessage,size, messages, newMessage}
}